// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Comment = function Comment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.827 15.285a1.88 1.88 0 0 1 1.743-.25c1.035.375 2.195.59 3.43.59 4.87 0 8.124-3.145 8.124-6.25S14.87 3.125 10 3.125c-4.87 0-8.125 3.145-8.125 6.25 0 1.25.485 2.453 1.395 3.484.336.38.5.88.46 1.387a7 7 0 0 1-.44 1.93 10 10 0 0 0 1.538-.887zm-4 1.586q.105-.157.2-.316c.39-.649.761-1.5.835-2.457C.691 12.766 0 11.137 0 9.375 0 4.887 4.476 1.25 10 1.25c5.524 0 10 3.637 10 8.125S15.523 17.5 10 17.5c-1.449 0-2.824-.25-4.066-.7-.465.34-1.223.805-2.121 1.196a9.6 9.6 0 0 1-1.957.629q-.048.01-.094.02c-.172.03-.34.058-.516.074-.008 0-.02.004-.027.004q-.299.03-.598.03a.625.625 0 0 1-.445-1.065q.239-.247.441-.528.1-.135.188-.27l.012-.019z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
